<div
  class="avatar-wrapper"
  [ngClass]="'size-' + size"
>
  <!-- if a user is anonymous, display a place holder avatar. -->
  <ion-avatar
    *ngIf="userIsAnonymous()"
    [ngClass]="'size-' + size"
    aria-hidden="true"
  >
    <img
      src="assets/img/mable/default_avatar.png"
      alt="person silhouette"
    />
  </ion-avatar>

  <!-- if avatar exists display avatar -->
  <ion-avatar
    *ngIf="!isDefaultImage && avatar && !userIsAnonymous()"
    [ngClass]="'size-' + size"
    (click)="enlargeImage()"
    [ariaHidden]="!avatarAltText"
  >
    <img
      src="{{ avatar }}"
      [alt]="avatarAltText || ''"
    />
  </ion-avatar>

  <!-- else display initials -->
  <div
    *ngIf="isDefaultImage && !userIsAnonymous() && name"
    [ngClass]="'user-avatar size-' + size"
    aria-hidden="true"
  >
    <span [ngStyle]="{ 'font-size': font + 'px' }"> {{ initials }}</span>
  </div>

  <!-- If user object is null, show "?" -->
  <div
    *ngIf="!name && !avatar"
    [ngClass]="'user-avatar no-user size-' + size"
    aria-hidden="true"
  >
    <span [ngStyle]="{ 'font-size': font + 'px' }">?</span>
  </div>

  <ion-badge
    [ngClass]="'size-' + size"
    class="availability"
    *ngIf="isOnline"
  >
  </ion-badge>

  <app-loyalty-badge
    *ngIf="loyaltyBadgeLevel && !isOnline"
    [level]="loyaltyBadgeLevel"
    [variant]="loyaltyBadgeVariant"
    class="avatar-badge"
    size="small"
  />

  <ng-content select="[slot=left-top]"></ng-content>
  <ng-content select="[slot=right-bottom]"></ng-content>
</div>
